module.exports = __webpack_public_path__ + "fonts/GalanoGrotesque-ExtraBold.578cf3f.woff";